import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito tener diagnóstico de TDAH para que esto funcione?',
  a: 'No. El sistema está diseñado para cualquier mujer que se identifique con los síntomas de caos mental, parálisis, procrastinación y desregulación emocional, independientemente de si tiene o no un diagnóstico formal.'
}, {
  q: '¿Cuánto tiempo por día necesito dedicarle?',
  a: 'El sistema mínimo viable puede implementarse con 20 a 30 minutos por día. Los tomos están diseñados para leerse a tu ritmo, no para devorarse de una vez.'
}, {
  q: '¿Cómo recibo el producto?',
  a: 'Inmediatamente después de completar el pago recibís un email con el link de descarga. Es un PDF descargable que podés leer en cualquier dispositivo: celular, tablet o computadora.'
}, {
  q: '¿Vale la pena pagar $10.000 más por el Bundle Completo?',
  a: 'Por $10.000 adicionales llevás la Agenda de Micro-Dosis (tu sistema de ejecución diaria) y el Freno de Emergencia (tu sistema financiero anti-impulso). Son los dos sistemas que convierten el conocimiento en resultados visibles todos los días.'
}, {
  q: '¿Funciona si ya probé mil sistemas y ninguno funcionó?',
  a: 'Probablemente los sistemas que probaste antes asumían que tu cerebro funciona de manera estándar. Este no. Está construido sobre cómo funciona específicamente el cerebro con desregulación dopamínica.'
}];
export const FAQSection = () => {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-143">
      <div className="max-w-3xl mx-auto" data-id="element-144">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-serif font-bold text-center text-dark mb-8" data-id="element-145">
          Preguntas frecuentes
        </motion.h2>

        <div className="space-y-3" data-id="element-146">
          {faqs.map((faq, idx) => <div key={idx} className="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm" data-id="element-147">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-5 py-4 text-left flex items-center justify-between focus:outline-none" data-id="element-148">
                <span className="font-bold text-dark text-base sm:text-lg pr-4" data-id="element-149">
                  {faq.q}
                </span>
                <ChevronDown className={`text-gold-500 transition-transform duration-300 shrink-0 ${openIdx === idx ? 'rotate-180' : ''}`} size={20} data-id="element-150" />
              </button>
              <AnimatePresence data-id="element-151">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-152">
                    <div className="px-5 pb-4 text-gray-600 text-sm sm:text-base leading-relaxed border-t border-gray-100 pt-3" data-id="element-153">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};